function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from '../DownloadDataModal.pcss';
const ResultsTableSegment = ({ labelMessage, value, icon, SubSegment })=>/*#__PURE__*/ _jsxs("div", {
        className: styles.strippedTable__segment,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row no-gutters justify-content-between px-5 py-3",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex align-items-center",
                        children: [
                            icon,
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, labelMessage))
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: value
                    })
                ]
            }),
            SubSegment && /*#__PURE__*/ _jsx("div", {
                className: styles.strippedTable__subSegment,
                children: /*#__PURE__*/ _jsx(SubSegment, {})
            })
        ]
    });
export default ResultsTableSegment;
